import { Switch } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import './ToggleButton.scss'; 

type Props = {
    labelText: React.ReactNode;
    checked: boolean;
    disabled?: boolean;
    prefixText?: string;
    setChecked: (val: boolean) => void;
}

const ToggleButton = ({ labelText, disabled = false, prefixText = "", checked, setChecked } : Props) => {
	const { t } = useTranslation();

    return <div className="ant-row ant-form-item toggle-btn">
        <div className="ant-col">
            <label>{labelText}</label>
        </div>
        <div className="ant-col">
            <div>
                {prefixText && <span className="prefix">{t(`${prefixText}.${checked ? "enabled" : "disabled"}`)}</span>}
                <Switch disabled={disabled} checked={checked} onChange={(value) => setChecked(value)} />
            </div>
        </div>
    </div>
}

export default ToggleButton;